export const DEPARTMENT_ID_PT = 1;
export const DEPARTMENT_ID_MT = 2;
export const DEPARTMENT_ID_PV = 3;
export const DEPARTMENT_ID_FULCTUATION = 4;

const productDepartments = [
  { id: DEPARTMENT_ID_PT, name: "PT" },
  { id: DEPARTMENT_ID_MT, name: "MT" },
  { id: DEPARTMENT_ID_PV, name: "PV" },
  { id: DEPARTMENT_ID_FULCTUATION, name: "FLUCTUATION" },
];
const productItems = [
  /**PT */
  {
    id: 1,
    name: "パネルタンク",
    department: "PT",
  },
  {
    id: 5,
    name: "MOPIT-W（花型タンク）",
    department: "PT",
  },
  {
    id: 8,
    name: "MOPIT-SE（緊急タンク）",
    department: "PT",
  },
  {
    id: 9,
    name: "MOPIT-S",
    department: "PT",
  },
  {
    id: 89,
    name: "緊急遮断弁",
    department: "PT",
  },
  {
    id: 92,
    name: "リースタンク",
    department: "PT",
  },
  /**MT */
  {
    id: 2,
    name: "MOPIT-X（円筒タンク）",
    department: "MT",
  },
  {
    id: 3,
    name: "MOPIT-Y（角タンク）",
    department: "MT",
  },
  {
    id: 4,
    name: "MOPIT-Z（長円タンク）",
    department: "MT",
  },
  {
    id: 6,
    name: "MOPIT-XT（タワー型）",
    department: "MT",
  },
  /**PV */
  {
    id: 10,
    name: "貯湯槽",
    department: "PV",
  },
  {
    id: 15,
    name: "圧力タンク",
    department: "PV",
  },
  {
    id: 16,
    name: "産業用圧力タンク",
    department: "PV",
  },
  {
    id: 17,
    name: "耐震性貯水槽",
    department: "PV",
  },
  {
    id: 20,
    name: "熱交換器",
    department: "PV",
  },
  {
    id: 30,
    name: "ヘッダー",
    department: "PV",
  },
  {
    id: 40,
    name: "オイルタンク",
    department: "PV",
  },
  {
    id: 50,
    name: "オイルサービスタンク",
    department: "PV",
  },
  {
    id: 60,
    name: "その他角丸タンク",
    department: "PV",
  },
  {
    id: 61,
    name: "貯水機能付給水管",
    department: "PV",
  },
  {
    id: 62,
    name: "球形タンク（開放式）",
    department: "PV",
  },
  {
    id: 65,
    name: "密閉式膨張タンク",
    department: "PV",
  },
  {
    id: 81,
    name: "ｺｲﾙ取り替え工事",
    department: "PV",
  },
  {
    id: 88,
    name: "プラント用槽類",
    department: "PV",
  },
  {
    id: 90,
    name: "気水分離器",
    department: "PV",
  },
  /**変動 */
  {
    id: 85,
    name: "補修、追加工事",
    department: "FLUCTUATION",
  },
  {
    id: 70,
    name: "部品類",
    department: "FLUCTUATION",
  },
  {
    id: 80,
    name: "雑工事",
    department: "FLUCTUATION",
  },
  {
    id: 95,
    name: "サービス工事",
    department: "FLUCTUATION",
  },
  {
    id: 91,
    name: "内張りタンク",
    department: "FLUCTUATION",
  },
  {
    id: 83,
    name: "配水池関連工事",
    department: "FLUCTUATION",
  },
  {
    id: 86,
    name: "保守・メンテナンス",
    department: "FLUCTUATION",
  },
  {
    id: 23,
    name: "ＰＨＥ部品、工事",
    department: "FLUCTUATION",
  },
  {
    id: 84,
    name: "タンク据付工事",
    department: "FLUCTUATION",
  },
  {
    id: 22,
    name: "プレート熱交換器",
    department: "FLUCTUATION",
  },
  {
    id: 65,
    name: "密閉式膨張タンク",
    department: "FLUCTUATION",
  },
  {
    id: 79,
    name: "煙道工事",
    department: "FLUCTUATION",
  },
  {
    id: 96,
    name: "残工事",
    department: "FLUCTUATION",
  },
  {
    id: 66,
    name: "スパイラル熱交",
    department: "FLUCTUATION",
  },
  {
    id: 82,
    name: "建築用解体・撤去",
    department: "FLUCTUATION",
  },
  {
    id: 25,
    name: "ヒートポンプシステム一式",
    department: "FLUCTUATION",
  },
  {
    id: 87,
    name: "遠隔監視システム",
    department: "FLUCTUATION",
  },
  {
    id: 75,
    name: "航空宇宙部品",
    department: "FLUCTUATION",
  },
  {
    id: 97,
    name: "不請求工事",
    department: "FLUCTUATION",
  },
  {
    id: 93,
    name: "保管管理",
    department: "FLUCTUATION",
  },
];

function findProductNameById(id) {
  // 与えられたIDで製品を検索
  const product = productItems.find((product) => product.id === id);

  // 製品が見つかればその名前を返し、見つからなければ'不明'を返す
  return product ? product.name : "不明";
}

function findProductIdListByDep(department) {
  // 与えられたIDで製品を検索
  const product = productItems.filter(
    (product) => product.department === department
  );
  const productIds = product.map((product) => product.id);
  return productIds;
}

export {
  productItems,
  findProductNameById,
  findProductIdListByDep,
  productDepartments,
};
